
import { useState, useEffect, useCallback } from 'react';

export const useBehavioralUX = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [showStickyElements, setShowStickyElements] = useState(false);
  const [exitIntentShown, setExitIntentShown] = useState(false);

  // Track scroll position
  useEffect(() => {
    const handleScroll = () => {
      const position = window.pageYOffset;
      setScrollPosition(position);
      
      // Show sticky elements after scrolling 300px
      setShowStickyElements(position > 300);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Exit intent detection
  useEffect(() => {
    const handleMouseLeave = (e) => {
      // Check if user has already submitted email or dismissed the modal
      const emailSubmitted = localStorage.getItem('price-alert-email-submitted');
      const modalDismissed = localStorage.getItem('exit-intent-dismissed');
      
      if (e.clientY <= 0 && !exitIntentShown && !emailSubmitted && !modalDismissed) {
        setExitIntentShown(true);
      }
    };

    document.addEventListener('mouseleave', handleMouseLeave);
    return () => document.removeEventListener('mouseleave', handleMouseLeave);
  }, [exitIntentShown]);

  const resetExitIntent = useCallback(() => {
    setExitIntentShown(false);
  }, []);

  return {
    scrollPosition,
    showStickyElements,
    exitIntentShown,
    resetExitIntent
  };
};
